/** Native full-board surfaces, shared by live boards and document previews.
 * Catalog image names are identifiers, never URLs. Only shipped assets may resolve.
 */
export interface BoardSurfaceRendering { boardImageName?: string | null; boardShaderId?: string | null }
const BOARD_IMAGES: Readonly<Record<string, string>> = {
  board_zen_chess: '/boards/board_zen_chess',
};
const SQUARE_MATERIALS: Readonly<Record<string, string>> = {
  'core.woodgrain': '/boards/heritage-grain.png',
  'core.linen': '/boards/linen.png',
};

/** The safe baseline asset, also useful to preload an approved native surface. */
export function boardImageUrl(name: string | null | undefined): string | null {
  const base = name && Object.hasOwn(BOARD_IMAGES, name) ? BOARD_IMAGES[name] : undefined;
  return base ? `${base}_1x.png` : null;
}

/** Web surface variables extend the canonical exported colors without changing them. */
export function boardSurfaceVariables(rendering: BoardSurfaceRendering): [string, string][] {
  const image = boardImageUrl(rendering.boardImageName);
  const base = image?.replace('_1x.png', '');
  const shader = rendering.boardShaderId;
  const material = shader && Object.hasOwn(SQUARE_MATERIALS, shader) ? SQUARE_MATERIALS[shader] : undefined;
  const grain = !image && material ? `url("${material}")` : 'none';
  const fullBoard = base ? `image-set(url("${base}_1x.png") 1x, url("${base}_2x.png") 2x, url("${base}_3x.png") 3x)` : 'none';
  return [
    ['--board-surface-image', fullBoard],
    ['--board-surface-square-image', grain],
    ['--board-surface-swatch-image', image ? fullBoard : grain],
    ['--board-surface-swatch-blend', image ? 'normal' : 'multiply'],
    ['--board-surface-swatch-size', image ? '800% 800%' : '100% 100%'],
    ['--board-surface-swatch-dark-position', image ? '14.285714% 0%' : '0% 0%'],
    ['--board-surface-light', image ? 'transparent' : 'var(--chroma-light-square)'],
    ['--board-surface-dark', image ? 'transparent' : 'var(--chroma-dark-square)'],
  ];
}
